<template>
	<Form :label-width="80" >
        <Form-item label="标题">
            <Input type="text" v-model="formItem.title"></Input>
        </Form-item>
        <Form-item label="H5链接">
            <Input type="text" v-model="formItem.url"></Input>
        </Form-item>
        <Form-item label="内容">
            <Input type="textarea" v-model="formItem.content"></Input>
        </Form-item>
        <Form-item label="开始时间">
            <Date-picker type="datetime" style="width:100%" placeholder="选择日期和时间" v-model="formItem.sdate"></Date-picker>
        </Form-item>
        <Form-item label="结束时间">
            <Date-picker type="datetime" style="width:100%" placeholder="选择日期和时间" v-model="formItem.edate"></Date-picker>
        </Form-item>
    </Form>
</template>
<script>
    import { mapState } from 'vuex'
	export default{
		data(){
			return {
				formItem:{
                    title:null,
                    city:null,
                    url:null,
                    sdate:null,
                    edate:null,
                    uids:null,
                },
			}
		},
		created(){
			this.$store.dispatch('parent2ShowFn');
            this.getData();
		},
		methods:{
            getData(){
                var _this=this;
                this.$http.get('/web/broadCast/getBroadCast',{
                    params:{
                        bcid:_this.$route.query.bcid,
                    }
                }).then(function(res){
                    _this.formItem=res.data;
                    _this.$Message.success('加载成功');
                }).catch(function(res){
                    _this.$Message.error('加载失败');
                })
            }
		}
	}
</script>
<style scoped>
	
</style>


// WEBPACK FOOTER //
// src/components/push/seeNews.vue